import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=4526bdd4&"
import script from "./Protocol.vue?vue&type=script&lang=js&"
export * from "./Protocol.vue?vue&type=script&lang=js&"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=4526bdd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports